import { render, staticRenderFns } from "./PtSelect.vue?vue&type=template&id=124408a6"
import script from "./PtSelect.vue?vue&type=script&lang=js"
export * from "./PtSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports